import React, { ChangeEvent } from 'react';
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Slide,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { useThemeContext } from '../../../hook/useThemeManager';
import { ColorScheme, theme } from '../../../constants/theme';
import { TransitionProps } from '@mui/material/transitions';
import x from '../../../asset/images/icons/es_x_white.svg';
import { StyleSheet } from 'react-native';
import { FONT_ENUM } from '../../../types/global/fonts.types';
import { ISendCampaignEmailProps } from '../../Cards/SendCampaignEmailModal';
import { IFormState } from '../../EsContestSubmission/EsContestSubmission';
import SendCampaignEmailModal from '../../Cards/SendCampaignEmailModal';

export interface ISendCampaignEmailModalContainer extends ISendCampaignEmailProps {
    onClose?: () => void;
    open: boolean;
    onSubmit: (formData: IFormState) => void;
    onChange?: (e?: ChangeEvent<HTMLInputElement>) => void;
}

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const SendCampaignEmailModalContainer: React.FC<ISendCampaignEmailModalContainer> = props => {
    const { open, onClose, onChange } = props;
    const { themeStyle } = useThemeContext();
    const themeui = useTheme();
    const fullScreen = useMediaQuery(themeui.breakpoints.down('md'));
    const styles = dynamicStyles(themeStyle);

    const renderProject = (
        <Dialog
            scroll="paper"
            open={open}
            onClose={onClose}
            TransitionComponent={Transition}
            fullWidth={true}
            fullScreen={fullScreen}
            maxWidth={'sm'}
            PaperProps={{
                style: {
                    // backgroundColor: fullScreen ? 'rgba(0, 0, 0)' : 'rgba(0, 0, 0, 0.8)', // make this a color variable
                    backgroundColor: theme[themeStyle].black,
                    width: '100vw',
                    // maxWidth: contentType === 'contest' ? '1058px' : '500px',
                    borderRadius: fullScreen ? 0 : 20,
                    border: `0.5px solid ${theme[themeStyle].darkGray60}`,
                    backdropFilter: 'blur(8px)',
                    margin: 0,
                },
            }}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                outline: 'none',
            }}>
            <DialogTitle>
                <Box
                    sx={{
                        width: '100%',
                        height: 'fit-content',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}>
                    <Typography
                        style={{
                            textAlign: 'left',
                            fontSize: 24,
                            fontStyle: 'normal',
                            fontWeight: '600',
                            color: theme[themeStyle].lightWhite,
                            fontFamily: FONT_ENUM.MAIN_BOLD,
                        }}>
                        Send Campaign Emails
                    </Typography>
                    <IconButton style={styles.close} onClick={onClose} sx={{ '&:hover': { cursor: 'pointer' } }}>
                        <img src={x} alt="close button" loading="lazy" />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                <SendCampaignEmailModal {...props} onChange={onChange} />
            </DialogContent>
        </Dialog>
    );

    return renderProject;
};

const dynamicStyles = (colorScheme: ColorScheme) =>
    StyleSheet.create({
        close: {
            width: 'fit-content',
            height: 'fit-content',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
        },
        title: {
            textAlign: 'left',
            fontSize: 24,
            fontStyle: 'normal',
            fontWeight: '600',
            color: theme[colorScheme].primary_white,
            fontFamily: FONT_ENUM.MAIN_BOLD,
        },
    });

export { SendCampaignEmailModalContainer };
